import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CommentsSideBar } from '@components-clean/core/comments-side-bar';
import { CTQFactorsContext } from '@pages-clean/risk-assessment/interfaces/context';
import { CommentEntityType } from 'types/graphql-global-types';
import { Permissions } from '@contexts/user-context';
import { useAuthorization } from '@hooks/index';
import Constants from '@utils/constants';

const CtqCommentsSideBar = () => {
    const { current } = useContext(CTQFactorsContext);
    const { t } = useTranslation('ram');
    const user = useAuthorization();
    const userHasWritePermission = !!user?.canWrite?.({
        module: Constants.Modules.RAM,
        element: Constants.DataElements.RiskAssessmentCtqComments,
        permission: Permissions.ReadWrite,
    });

    return (
        <CommentsSideBar
            studyId={current.study!.id}
            entityType={CommentEntityType.CTQ}
            messageHubRelativeEndpoint="ctq-hub"
            parentId={current.selectionState.selectedItem?.id}
            noParentSelectedMessage={t('ctqf.ctqFactors.noParentRecordSelected')}
            writeEnabled={userHasWritePermission}
        />
    );
};

export default CtqCommentsSideBar;
